import { Typography } from "@mui/material";

export default function Pageheader(props) {
  return (
    <Typography  variant="h4" sx={{color: "primary",  fontWeight: "bold" }}>
      {props?.headerName}
    </Typography>
  );
}
